<div *ngIf="loader" class="d-flex justify-content-center align-items-center">
  <mat-spinner class="spinner-duplicate" [diameter]="diameter"></mat-spinner>
</div>
